import { useQuery } from "@tanstack/react-query";
import { fetchDocumentChunks } from "../Api/documents";

export const useDocumentChunks = (documentId: number | null, enabled: boolean) => {
  return useQuery<unknown, Error>({
    queryKey: ["documentChunks", documentId],
    queryFn: () => fetchDocumentChunks(documentId!),
    enabled: enabled && !!documentId,
  });
};
